// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"47":"87690cca","287":"7ed21344","454":"91d88be0","472":"4199c460","478":"d6d289d6","489":"c441e713","831":"4e8c91e6","997":"6f81fa8d"}[chunkId] + ".chunk.js";
};